import { put, call, takeLatest, select } from 'redux-saga/effects';

import Immutable from 'seamless-immutable';

import { get } from 'js-cookie';
import filter from 'lodash/filter';

import { formatError } from '../../../libs';
import recommendationsAPI from '../../api/recommendations';
import { Creators as ProductCreators } from '../../reducers/product';
import { Types, Creators as RecommendationsCreators } from '../../reducers/recommendations';
import { getState } from '../../utils/getState';
import getToken from '../../utils/getToken';

function* requestRecomendations(page, qtyProducts) {
  const { product, app, customer } = yield select(getState);
  const siteId = app.getIn(['config', 'siteId']);
  const token = yield select(getToken);

  if (page === 'product') {
    const params = {
      productId: product.getIn(['id']),
      sessionId: get('SMART_PID'),
      userAttribute: 'device:desktop',
    };

    if (qtyProducts) {
      params.maxQuantity = qtyProducts;
    }

    if (customer.getIn(['id'])) {
      params.customerId = customer.getIn(['id']);
    }

    return yield call(recommendationsAPI.product, product.getIn(['id']), params, siteId, token);
  }

  if (page === 'home') {
    const positions = app
      .getIn(['config', 'positions', page], [])
      .filter((item) => item.show && item.type === 'recommendation');

    const recommendations = positions.map((item) => ({
      id: item.id,
      type: app.getIn(['config', 'recommendations', page, item.id, 'type']),
    }));

    const homeParams = {
      placements: recommendations.map((item) => item.type).join('|'),
    };

    if (qtyProducts) {
      homeParams.maxQuantity = qtyProducts;
    }

    return yield call(recommendationsAPI.home, homeParams, siteId, token);
  }

  return { placements: [] };
}

function* getRecommendations({ page, qtyProducts }) {
  try {
    const { app } = yield select(getState);
    const positions = app
      .getIn(['config', 'positions', page], [])
      .filter((item) => item.show && item.type === 'recommendation');
    const recommendations = positions.map((item) => ({
      id: item.id,
      type: app.getIn(['config', 'recommendations', page, item.id, 'type']),
    }));

    const data = yield call(requestRecomendations, page, qtyProducts);

    const placements = {};
    (data.placements || []).forEach((item) => {
      placements[item.placement] = {
        title: item.strategyMessage,
        html: item.html,
        placement: item.placement,
        products: Immutable(item.products || item.recommendedProducts || []),
      };
    });

    const result = {};
    recommendations.forEach(({ id, type }) => {
      const placement = placements[type];
      if (placement) {
        result[id] = {
          title: placement.title,
          html: placement.html,
          products: placements[type].products,
          type,
        };
      }
    });

    yield put(RecommendationsCreators.getRecommendationsSuccess({ placements: result }));

    if (page === 'product') {
      const buyTogether = {};

      filter(result, (item) => item.type.includes('combo')).forEach(({ title, type, products }) => {
        buyTogether[type] = {
          title,
          products,
        };
      });

      yield put(ProductCreators.getBuyTogetherSuccess({ buyTogether }));
    }
  } catch (error) {
    yield put(RecommendationsCreators.getRecommendationsError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_RECOMMENDATIONS_REQUEST, getRecommendations);
}
